import React, { useState } from "react";
import "./floatingPasswordInput.css";

const FloatingPasswordInput = ({
  id = "password",
  value,
  onChange,
  placeholder = "Password",
  label = "Password",
  wrapperClassName = "form-floating mb-15px",
  inputClassName = "form-control h-45px fs-13px",
  labelClassName = "d-flex align-items-center fs-13px",
}) => {
  const [visible, setVisible] = useState(false);

  return (
    <div className={`${wrapperClassName} position-relative floating-password-field`}>
      <input
        type={visible ? "text" : "password"}
        className={inputClassName}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        id={id}
        style={{ paddingRight: "2.75rem" }}
      />
      <label htmlFor={id} className={labelClassName}>
        {label}
      </label>
      <button
        type="button"
        className="floating-password-toggle"
        onClick={() => setVisible((prev) => !prev)}
        tabIndex={-1}
        aria-label={visible ? "Hide password" : "Show password"}
      >
        <i className={`fa ${visible ? "fa-eye-slash" : "fa-eye"}`} />
      </button>
    </div>
  );
};

export default FloatingPasswordInput;
